import { Box, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

interface CheckboxSectionCardProps {
  title: string;
  titleColor?: 'copper' | 'gunMetal';
  description?: ReactNode;
  children: ReactNode;
}

/** Titled, bordered card used to group a checkbox when autopay is required for this payment. */
const CheckboxSectionCard: FC<CheckboxSectionCardProps> = ({
  title,
  titleColor = 'gunMetal',
  description,
  children,
}) => (
  <>
    <Typography variant="h3" sx={{ color: (theme) => theme.palette.customColors[titleColor] }}>
      {title}
    </Typography>

    {description && (
      <Typography variant="body2" fontStyle="italic" sx={{ mt: 1, mb: 2 }}>
        {description}
      </Typography>
    )}

    <Box
      sx={{
        borderLeft: '6px solid',
        borderRadius: '4px',
        borderColor: (theme) => theme.palette.customColors.copper,
        backgroundColor: (theme) => theme.palette.customColors.lightYellow,
        py: 1.5,
        px: 3,
        mt: description ? 0 : 1,
      }}
    >
      {children}
    </Box>
  </>
);

export default CheckboxSectionCard;
